import { FilterOptionsDiscriminator } from 'src/components/filters/FilterOptionsDiscriminator';
import { useMemo } from 'react';
import { withQueries } from 'src/utils/reactQuery';
import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { Languages } from 'src/graphql/schema.graphql';
import { useUserQuery } from 'src/modules/user/hooks/useUserQuery';
import { useLanguagesQuery } from 'src/modules/user/hooks/useLanguagesQuery';
import {
  FilterBlockContainer,
  FilterLabel,
} from 'src/components/filters/FilterBlock';
import { FilterMultiselectDescription } from 'src/components/filters/types';
import { NCUserSession } from 'src/modules/user/models';

const FilterDescriptionBlock = styled.div`
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 100%;
  color: ${({ theme }) => theme.text.palette.secondary};
  margin-bottom: 8px;
`;

export const FilterLanguageBlock = withQueries(
  {
    user: useUserQuery,
    languages: useLanguagesQuery,
  },
  ({
    user,
    languages,
    filter,
  }: {
    user: NCUserSession;
    filter: FilterMultiselectDescription;
    languages: Languages[];
  }) => {
    const { _ } = useTranslate();
    const userLanguages = user?.identity.traits.language;
    const selectedLanguages =
      userLanguages && languages.filter((l) => userLanguages.includes(l.code));
    const filteredFilter = useMemo(
      () =>
        userLanguages
          ? {
              ...filter,
              options: filter.options.filter(
                (l) => !userLanguages.includes(l.value),
              ),
            }
          : filter,
      [filter, userLanguages],
    );
    return (
      <FilterBlockContainer>
        <div>
          <FilterLabel>{_(filter.title)}</FilterLabel>
          {selectedLanguages?.length ? (
            <FilterDescriptionBlock>
              from your profile:{' '}
              {selectedLanguages?.map((l, i) => (
                <span key={l.code}>
                  {i > 0 ? ', ' : ''}
                  {_(l.name)}
                </span>
              ))}
            </FilterDescriptionBlock>
          ) : null}
        </div>
        <FilterOptionsDiscriminator filter={filteredFilter} />
      </FilterBlockContainer>
    );
  },
);
